import Handlebars from "handlebars";

/**
 * Escapes a string for safe HTML output while preserving author-entered
 * `<br>` tags as real line breaks. Everything else is escaped, so admin
 * free-text cannot inject arbitrary markup (only `<br>` is allowed through).
 *
 * Used for titles that need manual line-break control (e.g. the Hero Banner
 * slideshow slide title).
 */
Handlebars.registerHelper("allowLineBreaks", function (string) {
  if (string === null || string === undefined) {
    return "";
  }

  // Coerce to a plain string before escaping: Handlebars.escapeExpression returns
  // SafeStrings unescaped (via toHTML), so coercing first guarantees a SafeString/
  // object can't bypass escaping through the template's triple-stash output. Then
  // restore only `<br>` variants (<br>, <br/>, <br />) that were escaped above.
  var escaped = Handlebars.escapeExpression(String(string)).replace(/&lt;br\s*\/?&gt;/gi, "<br>");

  return new Handlebars.SafeString(escaped);
});

/**
 * Plain-text counterpart of `allowLineBreaks` for attribute / plain-text
 * contexts (e.g. aria-label, image alt). Converts `<br>` variants to a single
 * space (so words aren't concatenated), strips any other tags, then escapes the
 * result. Returns a SafeString.
 */
Handlebars.registerHelper("lineBreaksToSpaces", function (string) {
  if (string === null || string === undefined) {
    return "";
  }

  var text = String(string)
    .replace(/<br\s*\/?>/gi, " ") // line breaks become spaces
    .replace(/<[^>]*>/g, "") // strip any remaining tags
    .replace(/\s+/g, " ") // collapse whitespace introduced above
    .trim();

  return new Handlebars.SafeString(Handlebars.escapeExpression(text));
});
